import * as jwt_decode from "jwt-decode";
import JwtToken from "interfaces/JwtToken";
import { useAccount, useMsal } from "../components/common/msal";
import getBaseUrl from "./getBaseUrl";

export default function getJwtToken(): JwtToken | null {

    let token = localStorage.getItem("access_token");

    if (token === null) {
        const { instance, accounts } = useMsal();
        const account = useAccount(accounts[0] || {});
        const baseUrl = getBaseUrl();

        let config = require(`../config.${HostingEnv}.ts`) as any;

        const scope = BQS
            ? config.authRequestBQS.scopes[0]
            : config.authRequestCQS.scopes[0];

        if (account) {
            instance
                .acquireTokenSilent({
                    scopes: [scope],
                    account: account,
                })
                .then((response) => {
                    if (response) {
                        localStorage.setItem("access_token", response.accessToken);
                        //console.log("getJwtToken: Access token acquired silently: ", response.accessToken);
                        return jwt_decode(response.accessToken) as JwtToken;
                    } else {
                        return null;
                    }
                })
                .catch((err) => {
                    //console.log("getJwtToken: Silent token acquisition failed, acquiring token interactively...", err);
                    instance.loginRedirect({
                        scopes: [scope],
                        account: account
                    });
                    return null;
                });
        } else {
            return null;
        }
    } else {
        return jwt_decode(token) as JwtToken;
    }
    return null;
}


// WEBPACK FOOTER //
// ./ClientApp/utils/getJwtToken.ts